import { render, staticRenderFns } from "./Linkedin.vue?vue&type=template&id=f9307f68&scoped=true&"
import script from "./Linkedin.vue?vue&type=script&lang=ts&"
export * from "./Linkedin.vue?vue&type=script&lang=ts&"
import style0 from "./Linkedin.vue?vue&type=style&index=0&id=f9307f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9307f68",
  null
  
)

export default component.exports